<template>
  <div
    class="modal fade"
    :id="`confirm-${pipeline.pipeline_id}`"
    tabindex="-1"
    aria-labelledby="devModal"
    aria-hidden="true"
    data-bs-backdrop="static"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div v-if="!toDelete && pipeline.interview.status === 1" class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="devModalLabel">
            Confirm interview
          </h5>
          <button
            ref="closeConfirmModal"
            type="button"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="clearRadios"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>
            If the request is closed, the customer will only be informed if a time slot has been
            selected. Calendar invites and requests for additional time slots are not sent by the
            system.
          </p>
          <div class="form-group m-label-left">
            <input
              disabled
              :value="pipeline.interview.requested_by"
              type="text"
              class="form-control mb-3"
            />
            <label>Requested by</label>
          </div>

          <div class="form-group m-label-left">
            <input
              v-if="pipeline.interview.location === 1"
              value="Video"
              disabled
              type="text"
              class="form-control mb-3"
            />
            <input
              v-if="pipeline.interview.location === 2"
              value="Face-to-Face"
              disabled
              type="text"
              class="form-control mb-3"
            />
            <input
              v-if="pipeline.interview.location === 3"
              value="Phone call"
              disabled
              type="text"
              class="form-control mb-3"
            />
            <label>Location</label>
          </div>

          <div v-if="pipeline.interview.location === 1" class="form-group m-label-left">
            <input
              :value="pipeline.interview.instructions"
              disabled
              type="text"
              class="form-control mb-3"
            />
            <label>Instructions to join</label>
          </div>

          <div v-if="pipeline.interview.location === 2" class="form-group m-label-left">
            <input
              :value="pipeline.interview.address"
              disabled
              type="text"
              class="form-control mb-3"
            />
            <label>Address</label>
          </div>

          <div class="form-group m-label-left">
            <textarea
              disabled
              :value="pipeline.interview.information"
              id="book-instructions"
              rows="3"
              class="form-control"
            ></textarea>
            <label for="book-instructions">Information</label>
          </div>
          <ul class="list-unstyled">
            <li v-for="(time, index) in pipeline.interview.timeslots" :key="index">
              <label>
                <input
                  type="radio"
                  :value="time.id"
                  v-model="selectedTimeConfirm"
                  @click="deselectRadio(time.id)"
                />
                <span>
                  {{
                    time.time
                      | formatDate({
                        format: getUserProfile.format_date,
                        timezone: getUserProfile.timezone,
                        hasHourAndMinutes: true,
                      })
                  }}
                </span>
              </label>
            </li>
          </ul>
        </div>
        <div class="modal-footer text-center justify-content-center">
          <button @click="confirmDate" type="button" class="btn btn-primary">
            {{ selectedTimeConfirm.length > 0 ? 'Close and confirm' : 'Decline all time slots' }}
          </button>
          <button
            @click="clearRadios"
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
        </div>
      </div>

      <div v-if="!toDelete && pipeline.interview.status === 2" class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="devModalLabel">
            Cancel interview
          </h5>
          <button
            ref="closeConfirmModal"
            type="button"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>
            Please be aware that there is a scheduled interview with
            <strong
              >{{ pipeline.first_name ? pipeline.first_name : getCandidateById.first_name }}
              {{ pipeline.last_name ? pipeline.last_name : getCandidateById.last_name }}</strong
            >

            <strong>
              {{
                getConfirmedTime(pipeline.interview.timeslots)
                  | formatDate({
                    format: getUserProfile.format_date,
                    timezone: getUserProfile.timezone,
                    hasHourAndMinutes: true,
                  })
              }}
              {{ getUserProfile.timezone_data.utc_timezone }}.</strong
            >
            You can't schedule a new interview before a confirmed interview has taken place (or has
            been cancelled).
          </p>
          <div class="form-group m-label-left">
            <input
              :value="getInterviewLocation(pipeline.interview.location)"
              disabled
              type="text"
              class="form-control mb-3"
            />
            <label>Location</label>
          </div>

          <div v-if="pipeline.interview.location === 1" class="form-group m-label-left">
            <input
              :value="pipeline.interview.instructions"
              disabled
              type="text"
              class="form-control mb-3"
            />
            <label>instructions to join</label>
          </div>

          <div v-if="pipeline.interview.location === 2" class="form-group m-label-left">
            <input
              :value="pipeline.interview.address"
              disabled
              type="text"
              class="form-control mb-3"
            />
            <label>Address</label>
          </div>

          <div class="form-group m-label-left">
            <textarea
              disabled
              :value="pipeline.interview.information"
              id="book-instructions"
              rows="3"
              class="form-control"
            ></textarea>
            <label for="book-instructions">Information</label>
          </div>

          <div class="form-group m-label-left">
            <input
              :value="pipeline.interview.requested_by"
              disabled
              type="text"
              class="form-control mb-3"
            />
            <label>Requested by</label>
          </div>
        </div>
        <div class="modal-footer text-center justify-content-center">
          <button @click="toDelete = true" type="button" class="btn btn-danger">
            Cancel interview
          </button>
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal">
            Don't cancel interview
          </button>
        </div>
      </div>

      <div v-if="toDelete && pipeline.interview.status === 2" class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="devModalLabel">
            Cancel interview
          </h5>
          <button
            ref="closeConfirmModal"
            type="button"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="handleClose"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>
            Please confirm that you want to cancel the scheduled interview with
            <strong
              >{{ pipeline.first_name ? pipeline.first_name : getCandidateById.first_name }}
              {{ pipeline.last_name ? pipeline.last_name : getCandidateById.last_name }}.</strong
            >
            The candidate will be notified via email about the cancellation. You need to inform the
            customer.
          </p>
        </div>
        <div class="modal-footer text-center justify-content-center">
          <button @click="cancelInterview" type="button" class="btn btn-danger">
            Cancel interview
          </button>
          <button
            @click="handleClose"
            type="button"
            class="btn btn-primary"
            data-bs-dismiss="modal"
          >
            Don't cancel interview
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment-timezone';
export default {
  props: {
    pipeline: {
      type: Object,
    },
  },
  data: () => ({
    selectedTimeConfirm: '',
    toDelete: false,
    booking: {
      selectedDates: [''],
      selectedLocation: '1',
      selectedAddress: '',
      videoInstructions: '',
      info: '',
    },
  }),
  methods: {
    getInterviewLocation(status) {
      if (status === 1) {
        return 'Video';
      } else if (status === 2) {
        return 'Face-to-face';
      } else {
        return 'Phone call';
      }
    },
    confirmDate() {
      if (this.selectedTimeConfirm !== '') {
        axios
          .post(
            `${process.env.VUE_APP_API_URL}/admin/interview/approve`,
            {
              timeslot_id: this.selectedTimeConfirm,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem(
                  `${process.env.VUE_APP_TOKEN_PREFIX}token`,
                )}`,
              },
            },
          )
          .then(res => {
            this.$refs.closeConfirmModal.click();
            this.$emit('update');
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        const timesArray = [];

        for (let i = 0; i < this.pipeline.interview.timeslots.length; i++) {
          timesArray.push(this.pipeline.interview.timeslots[i].time);
        }
        axios
          .post(
            `${process.env.VUE_APP_API_URL}/admin/interview/update`,
            {
              interview_id: this.pipeline.interview.interview_id,
              location: this.pipeline.interview.location,
              status: 3,
              timeslots_data: timesArray,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem(
                  `${process.env.VUE_APP_TOKEN_PREFIX}token`,
                )}`,
              },
            },
          )
          .then(() => {
            this.$refs.closeConfirmModal.click();
            this.$emit('update');
          });
      }
    },
    deselectRadio(timeId) {
      if (this.selectedTimeConfirm === timeId) {
        this.selectedTimeConfirm = '';
      }
    },
    clearRadios() {
      this.selectedTimeConfirm = '';
    },

    cancelInterview() {
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/admin/interview/cancel`,
          {
            interview_id: this.pipeline.interview.interview_id,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(res => {
          this.$refs.closeConfirmModal.click();
          this.toDelete = false;
          this.$emit('update');
          this.$toasted.success('Interview cancelled', {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        })
        .catch(err => {});
    },

    getConfirmedTime(time) {
      const confirmedSlot = time.find(slot => slot.confirmed_by !== null);
      const confirmedTime = confirmedSlot ? confirmedSlot.time : null;

      return confirmedTime; // "2025-02-13 12:00:00+00"
    },
    handleClose() {
      this.toDelete = false;
    },
  },

  computed: {
    ...mapGetters(['getUserProfile', 'getCandidateById']),
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.book-date {
  display: flex;
  margin-bottom: 15px;
  .form-control {
    margin-bottom: 0 !important;
  }
}
</style>
